module.exports = __webpack_public_path__ + "media/images/game_icon/th/AB1507-9829b75018b5abbb6622bc1be0e59ca6.png";